import React from 'react';
import { Box } from '@mui/material';
import TDDWorkflowManager from './TDDWorkflowManager';

/**
 * Split View TDD Component
 * Main container for TDD workflow interface
 * Follows the same pattern as other SplitView components
 */
const SplitViewTDD = ({ projectId }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Box sx={{ flex: 1 }}>
        <TDDWorkflowManager projectId={projectId} />
      </Box>
    </Box>
  );
};

export default SplitViewTDD;